/*!
 *   Copyright 2022  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

@import "../../scss/vars";
@import "../../scss/gts";

:host {
  width: 100%;
  height: 100%;
  position: relative;

  & > div {
    width: 100%;
    height: calc(100% - 10px);
    position: relative;
    display: flex;
    justify-content: start;
    flex-direction: column;

    &.vertical-wrapper {
      flex-direction: row;
      justify-content: center;
    }
  }

  .wv-tooltip {
    position: absolute;
    width: auto;
    height: auto;
    display: none;
    border-style: solid;
    white-space: nowrap;
    z-index: 9999999;
    box-shadow: rgba(0, 0, 0, 0.2) 1px 2px 10px;
    transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, transform 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s;
    background-color: rgba(255, 255, 255, 0.8);
    border-width: 1px;
    border-radius: 4px;
    color: rgb(102, 102, 102);
    font: 14px / 21px sans-serif;
    padding: 10px;
    top: 0;
    left: 0;
    transform: translate3d(30px, 10px, 0px);
    border-color: rgb(255, 255, 255);
    pointer-events: none;

    .label {
      font-size: 14px;
      color: #666;
      font-weight: 400;
      margin-left: 2px;
    }

    .value {
      float: right;
      margin-left: 20px;
      font-size: 14px;
      color: #666;
      font-weight: 900;
    }

    div {
      word-wrap: anywhere;
    }
  }

  .discovery-chart-spinner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    z-index: 900;
  }

  .discovery-progress-group {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: start;
    height: auto;
    margin: 10px;

    p {
      margin-top: 0;
    }

    .small {
      font-size: 0.8em;
    }

    h3.discovery-legend {
      margin: 0;
      text-align: center;
      color: var(--warp-view-font-color, $w10-charcoal);
    }

    .discovery-progress-container-horizontal {
      display: flex;
      flex-direction: row;
      font-size: .75rem;
      background-color: var(--warp-view-progress-bg-color, #e9ecef);
      border-radius: 0.25rem;
      border: solid 1px var(--warp-view-chart-grid-color, #8e8e8e);
      height: var(--warp-view-progress-size, 1rem);
      width: 100%;
    }

    .discovery-progress-container-vertical {
      display: flex;
      flex-direction: row;
      font-size: .75rem;
      background-color: var(--warp-view-progress-bg-color, #e9ecef);
      border-radius: 0.25rem;
      border: solid 1px var(--warp-view-chart-grid-color, #8e8e8e);
      width: var(--warp-view-progress-size, 1rem);
      height: 100%;
    }

    .discovery-progress {
      display: flex;
      width: 100%;
      height: 100%;
      overflow: hidden;

      &.positive {
        border-left: solid 1px var(--warp-view-chart-grid-color, #8e8e8e);
      }

      &.negative {
        border-right: solid 1px var(--warp-view-chart-grid-color, #8e8e8e);
        justify-content: end;
      }

      &:hover {
        cursor: pointer;
      }

      .ticks {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: var(--warp-view-progress-size, 1rem);
        display: flex;
        flex-direction: row;
        align-items: end;
        justify-content: space-evenly;

        .tick {
          width: 1px;
          height: var(--warp-view-progress-size, 1rem);
          background-color: var(--warp-view-chart-grid-color, #8e8e8e);
        }
      }

      .discovery-progress-bar {
        display: flex;
        flex-direction: column;
        justify-content: center;
        overflow: hidden;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        transition: width .6s ease;
        // border-radius: 0.25rem;
      }
    }

    &.discovery-progress-group-vertical {
      height: 100%;
      flex-flow: column-reverse;
      align-items: center;
      justify-content: center;
      width: auto;

      .discovery-progress {
        width: var(--warp-view-progress-size, 1rem);
        height: 100%;
        align-items: end;
        position: relative;

        .ticks {
          height: 100%;
          width: var(--warp-view-progress-size, 1rem);
          display: flex;
          flex-direction: column;
          align-items: start;
          justify-content: space-evenly;
          bottom: unset;
          left: auto;
          right: auto;
          top: 0;

          .tick {
            height: 1px;
            width: var(--warp-view-progress-size, 1rem);
          }
        }

        .discovery-progress-bar {
          transition: height .6s ease;

        }
      }
    }
  }

}
